import React, {Fragment} from 'react';
import Selector from "canvas-core-react/lib/Selector";

const InputSelect = ({id, label, placeholder, value, setTo, options, error, tooltip})=> {
    const onChange = (selected)=> {
        const _value = options.list.find((option)=> option[options.description] === selected);
        setTo(_value);
    };

    const optionsComponent = options.list.map((element)=> {
        return <option id={element[options.id]} key={element[options.id]}>{element[options.description]}</option>;
    });

    return (
        <Fragment>
            <InputSelector
                id={id}
                label={label}
                placeholder={placeholder}
                value={value}
                description={options.description}
                error={error}
                optionsComponent={optionsComponent}
                onChange={onChange}
                disabled={!optionsComponent.length}
                tooltip={tooltip}
            />
        </Fragment>
    );
};

const InputSelector = ({id, label, placeholder, value, description, error, optionsComponent, onChange, disabled, tooltip})=> {
    return (
        <Selector
            id={id}
            name={id}
            label={label}
            placeholder={placeholder}
            value={value[description]}
            onChange={(e)=> onChange(e.target.value)}
            error={error ? {label: 'Error', messages: [error]} : null}
            secondaryLabel={tooltip}
            disabled={disabled}
        >
            {optionsComponent}
        </Selector>
    );
};

InputSelect.defaultProps = {
    name: '',
    value: '',
    options: [],
    error: null,
    searcher: true
};

export default InputSelect;
